import { graphql } from 'react-relay';

export const performanceOverviewMenuFragment = graphql`
    fragment PerformanceOverviewMenu_menu on PerformanceOverviewMenu {
        xlsdownloadtext
        currencySelectionInfo
        currencySelectionHeader
        currencySelectionSaveButtonText
    }
`;
